import React, {createContext, useState} from 'react';
import PropTypes from 'prop-types';

export const LocationContext = createContext({});

export const Provider = (props) => {
  const {children} = props;

  const [selectedLocation, setSelectedLocation] = useState(null);
  const [reloading, setReloading] = useState(false);

  const locationContext = {
    selectedLocation,
    setSelectedLocation,
    reloading,
    setReloading,
  };

  return (
    <LocationContext.Provider value={locationContext}>
      {children}
    </LocationContext.Provider>
  );
};

export const {Consumer} = LocationContext;

Provider.propTypes = {
  children: PropTypes.any,
};
